import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import * as regServiceWorker from './registerServiceWorker';
import ReduxToastr from 'react-redux-toastr'
import 'react-redux-toastr/lib/css/react-redux-toastr.min.css'
import axios from 'axios';
import 'react-quill/dist/quill.snow.css';

// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href') as string;
const history = createBrowserHistory({ basename: baseUrl });
var siteThemeLocalStroage: any = localStorage.getItem('siteTheme');



var siteTheme: any = "";
if (siteThemeLocalStroage != "") {
    siteTheme = JSON.parse(siteThemeLocalStroage);
}
else {
    var styles: any = {
        "primary-color": "#15558d",
        "secondary-color": "#15558d",
        "link-color": "#272b41",
        "title-color": "#272b41",
        "subtitle-color": "#272b41",
        "lightDescription-color": "#757575",
        "fillText-color": "#fff",
        "bodyText-color": "#272b41"
    };
    siteTheme = styles;
}

if (siteTheme != undefined) {
    Object.keys(siteTheme).forEach(function (key) {
        document.documentElement.style.setProperty('--' + key, siteTheme[key]);
    })
}
const store = configureStore(history);

// Function to clear the console
//const clearConsole = () => {
//    console.clear();
//};


//setInterval(() => {
//    clearConsole()
//}, 60000)


// Set interval to clear console every minute (60000 milliseconds)

const getClientAccess = () => {
    axios.get('/account/getaccess/', { headers: { Authorization: "BasicAuth" } })
        .then(function (response) {
            ReactDOM.render(
                <Provider store={store}>
                    <ConnectedRouter history={history}>
                        <App />
                    </ConnectedRouter>
                    <ReduxToastr preventDuplicates position="top-right" timeOut={3000} />
                </Provider>,
                document.getElementById('root'));
            registerServiceWorker();
        })
        .catch(error => {
            console.log("Please check Client details")
        })
        .then(function () {
    });
}
getClientAccess();
// Get the application-wide store instance, prepopulating with state from the server where available.


